import axios from 'axios/index';
import React, {Component} from 'react';
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import NoFeeds from "./feed/NoFeeds";
// import ReactGA from "react-ga";
import {
    Popover, Classes, Position, Menu, MenuDivider, MenuItem, Button, Icon, Tooltip
} from "@blueprintjs/core";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import CustomFieldModal from "../modals/CustomFieldModal";
import RetinaImage from "react-retina-image";


class CustomFields extends Component {
    state = {
        user: this.props.user,
        selectedSource: this.props.selectedSource,
        customFields:
        // [],
            [
                {
                    field_name: 'company_name',
                    field_type: 'Text',
                    date_created: '22/12/2018',
                    personalization: true
                },
                {
                    field_name: 'title',
                    field_type: 'Text',
                    date_created: '22/12/2018',
                    personalization: true
                },
                {
                    field_name: 'birth_date',
                    field_type: 'Date',
                    date_created: '22/12/2018',
                    personalization: false
                },
                {
                    field_name: 'age',
                    field_type: 'Number',
                    date_created: '22/12/2018',
                    personalization: true
                },
                {
                    field_name: 'hobby',
                    field_type: 'Text',
                    date_created: '22/12/2018',
                    personalization: true
                }
            ],
        reservedFields: [
            {
                field_name: 'company_name',
                field_type: 'Text',
                date_created: '22/12/2018',
                personalization: true
            },
            {
                field_name: 'title',
                field_type: 'Text',
                date_created: '22/12/2018',
                personalization: true
            },
            {
                field_name: 'birth_date',
                field_type: 'Date',
                date_created: '22/12/2018',
                personalization: false
            },
            {
                field_name: 'age',
                field_type: 'Number',
                date_created: '22/12/2018',
                personalization: true
            },
            {
                field_name: 'hobby',
                field_type: 'Text',
                date_created: '22/12/2018',
                personalization: true
            }
        ],
        customFieldModal: false,
        modalType: '',
        fieldName: '',
        fieldType: '',
        reservedField: false
    }

    getMuiTheme = () => createTheme({
        typography: {
            htmlFontSize: 12,
            fontFamily: 'Poppins',
            color: '#344A5E'
        },
        overrides: {
            MuiPaper: {
                elevation4: {
                    boxShadow: 'none',
                    border: '1px solid #D6DBDF'
                }
            },
            MUIDataTableBodyCell: {
                root: {
                    fontWeight: 600
                }
            },
            MUIDataTableHeadCell: {
                root: {
                    fontWeight: 600
                }
            },
            MuiTableRow: {
                root: {
                    transition: '.3s',
                    '&:nth-child(odd)': {
                        backgroundColor: '#FAFAFA'
                    }
                },
                hover: {
                    "&:hover": {
                        backgroundColor: "rgba(38, 170, 225, 0.2) !important"
                    }
                },

            },
            MuiIconButton: {
                label: {}
            },
            MUIDataTableSelectCell: {
                fixedLeft: {
                    zIndex: 1
                },
                root: {},
                checkboxRoot: {
                    color: "#D6DBDF !important",
                },
                checked: {
                    color: "#344A5E !important"
                },
            },
            MUIDataTableToolbarSelect: {
                root: {
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingRight: 20,
                    paddingLeft: 20,
                    backgroundColor: '#fff',
                    boxShadow: 'none',
                    zIndex: 1
                }
            },
            MuiTooltip: {
                tooltip: {
                    fontSize: 12,
                }
            },
            MuiInput: {
                underline: {
                    "&:after": {
                        borderBottom: '2px solid #18A9E3'
                    }
                }
            },
            MUIDataTableToolbar: {
                icon: {
                    "&:hover": {
                        color: '#18A9E3'
                    }
                },
                iconActive: {
                    color: '#18A9E3'
                }
            },
            MuiCheckbox: {
                colorPrimary: {
                    "&.Mui-checked": {
                        color: '#344A5E'
                    }
                }
            },
            MuiChip: {
                root: {
                    borderRadius: 4
                }
            },
            MuiButton: {
                textPrimary: {
                    color: '#18A9E3'
                }
            }
        }
    })

    componentDidMount = () => {
        // console.log('component mounted')
    }
    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            await this.setState({
                selectedSource: this.props.selectedSource
            })
        }
    }


    handleModal = async (modalType, fieldName, fieldType, reservedField) => {
        // console.log('modalType:', modalType)
        // console.log('fieldName:', fieldName)
        // console.log('fieldType: ', fieldType)

        await this.setState({
            customFieldModal: true,
            modalType: modalType,
            fieldName: modalType === 'create' ? '' : fieldName,
            fieldType: modalType === 'create' ? '' : fieldType,
            reservedField
        })
    }
    handleClose = async () => {
        await this.setState({
            customFieldModal: false

        })
    }


    render() {
        const customTableColumns = [
            {
                name: "field_name",
                label: "Field Name",
                options: {
                    filter: false,
                    sort: false
                }
            },
            {
                name: "field_type",
                label: "Field Type",
                options: {
                    filter: false,
                    sort: false
                }
            },
            {
                name: "date_created",
                label: "Date Created",
                options: {
                    filter: false,
                    sort: false
                }
            },
            {
                name: "personalization",
                label: "Personalization",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => {
                        return value ?
                            <img src="/img/double-tick-indicator.png" alt="available"/>
                            :
                            <img src="/img/material-close-grey.png" alt="unavailable"/>
                    }
                }
            },
            {
                name: "personalization",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        // console.log('value: ', value)
                        // console.log('tableMeta: ', tableMeta)
                        // console.log('updateValue: ', updateValue)
                        return <div className='grey-text f-16 custom-fields-actions'>
                            <i onClick={(e) => this.handleModal('edit', tableMeta.rowData[0], tableMeta.rowData[1], false)}
                               className='far fa-edit margin-right-20'></i>
                            <i onClick={(e) => this.handleModal('delete', tableMeta.rowData[0], tableMeta.rowData[1], false)}
                               className='fas fa-trash-alt'></i>
                        </div>
                    }

                }
            }
        ]
        const customTableOptions = {
            print: false,
            count: 5,
            search: false,
            download: false,
            filter: false,
            columns: false,
            viewColumns: false,
            selectableRows: 'none',
            rowsPerPageOptions: [10, 25, 50]
        }

        const reservedTableColumns = [
            {
                name: "field_name",
                label: "Field Name",
                options: {
                    filter: false,
                    sort: false
                }
            },
            {
                name: "field_type",
                label: "Field Type",
                options: {
                    filter: false,
                    sort: false
                }
            },
            {
                name: "date_created",
                label: "Date Created",
                options: {
                    filter: false,
                    sort: false
                }
            },
            {
                name: "personalization",
                label: "Personalization",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => {
                        return value ?
                            <img src="/img/double-tick-indicator.png" alt="available"/>
                            :
                            <img src="/img/material-close-grey.png" alt="unavailable"/>
                    }
                }
            },
            {
                name: "personalization",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        return <div className='grey-text f-16 custom-fields-actions'>
                            <i onClick={(e) => this.handleModal('edit', tableMeta.rowData[0], tableMeta.rowData[1], true)}
                               className='far fa-edit margin-right-20'></i>

                        </div>
                    }
                }
            }
        ]
        const reservedTableOptions = {
            print: false,
            count: 5,
            search: false,
            download: false,
            filter: false,
            columns: false,
            viewColumns: false,
            selectableRows: 'none',
            rowsPerPageOptions: [10, 25, 50]
        }

        return (
            <React.Fragment>
                <h1 className='main-title'>Custom fields</h1>
                <div
                    className="display-flex justify-content-space align-items-start margin-top-30 custom-fields-subtitle">
                    <p className='f-16'>
                        Custom fields allow you to store data about your recipients such as gender or geography. <br/>
                        You can use this data to create targeted segments or personalize content to better engage your
                        audience.
                    </p>
                    <button onClick={(e) => this.handleModal('create')} className='btn-action'>
                        New Custom Field
                    </button>
                </div>

                <div id='custom-fields' className='margin-top-20'>

                    {!this.state.customFields.length ?

                        <div className='custom-fields-empty'>
                            <RetinaImage src={['/img/custom-fields-emtpy.png', '/img/custom-fields-emtpy@2x.png']}
                                         alt='Custom fields empty'
                                         checkIfRetinaImgExists={false}
                            />
                            <h3>
                                You didn't create any Custom Field yet.
                            </h3>
                            <p>Create your first Custom Field by clicking on the button below.</p>
                            <button className='btn-action' onClick={(e) => this.handleModal('create')}>
                                New Custom Field
                            </button>
                        </div>
                        :
                        <MuiThemeProvider theme={this.getMuiTheme()}>
                            <MUIDataTable

                                title="Custom Fields"
                                data={this.state.customFields}
                                columns={customTableColumns}
                                options={customTableOptions}
                            />
                        </MuiThemeProvider>
                    }
                </div>
                <div id='reserved-fields' className='margin-top-20 margin-bottom-30'>
                    <MuiThemeProvider theme={this.getMuiTheme()}>
                        <MUIDataTable
                            title="Reserved Fields"
                            data={this.state.reservedFields}
                            columns={reservedTableColumns}
                            options={reservedTableOptions}
                        />
                    </MuiThemeProvider>
                </div>

                <CustomFieldModal
                    showModal={this.state.customFieldModal}
                    modalType={this.state.modalType}
                    fieldName={this.state.fieldName}
                    fieldType={this.state.fieldType}
                    handleClose={this.handleClose}
                    reservedField={this.state.reservedField}
                />
            </React.Fragment>

        )
    }

}


export default CustomFields